import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export const LoadingPage = () => {

  // token related code | start
  const queryParameters = new URLSearchParams(window.location.search)
  const token = queryParameters.get("token");
  const localStorageData = localStorage.getItem('token');
  console.log("token", token);

  // const queryParametersRFS = new URLSearchParams(window.location.search)
  const tokenASR = queryParameters.get("service_recovery_token");
  const localStorageDataASR = localStorage.getItem('ASR');

  const tokenRFS = queryParameters.get("rfstoken");
  const localStorageDataRFS = localStorage.getItem('RFS');

  const tokenULD = queryParameters.get("uldtoken");
  const userName = queryParameters.get("user_name");
  const orgType = queryParameters.get("org_type");
  const userEmail = queryParameters.get("email_id");
  const backUrl = queryParameters.get("back_url");
  const logOutPath = queryParameters.get("logout_path");
  const localStorageDataULD = localStorage.getItem('ULD');
  const logUrl = localStorage.getItem('LogOut');

  const tokenEmail = queryParameters.get('email_approval_token');
  const recEmail = queryParameters.get('email');
  const emailData = queryParameters.get('data');
  const localStorageDataEmail = localStorage.getItem('EMAIL');
  const userType = queryParameters.get("user_type");

  const history = useHistory();
  const location = useLocation();
  // alert("14");
  if (token != "" && token != null) {
    // alert("16");
    localStorage.setItem('token', token)
    queryParameters.delete('token');
    localStorage.removeItem('RFS');
    localStorage.removeItem('ULD');
    localStorage.removeItem('EMAIL');
    localStorage.removeItem('ASR');
    history.push({
      pathname: location.pathname,
    });
    window.location.replace(process.env.REACT_APP_PLANDASHBOARD_URL) // Redirect to planDashboard
    // navigate("/planDashboard");
    // return <Redirect to='/planDashboard'/>;
  } else if (localStorageData != "" && localStorageData != null) {
    window.location.replace(process.env.REACT_APP_PLANDASHBOARD_URL) // Redirect to planDashboard
  } else if (tokenRFS != "" && tokenRFS != null) {
    localStorage.setItem('RFS', tokenRFS)
    queryParameters.delete('rfstoken');
    localStorage.removeItem('token');
    localStorage.removeItem('ULD');
    localStorage.removeItem('EMAIL');
    localStorage.removeItem('ASR');
    history.push({
      pathname: location.pathname,
    });
    console.log('***', location.pathname);
    window.location.replace(process.env.REACT_APP_BOOKINGTRUCK_URL) // redirect to RFS dashboard
  } else if (tokenULD != "" && tokenULD != null) {
    localStorage.setItem('ULD', tokenULD);
    localStorage.setItem('User', userName);
    localStorage.setItem('Email', userEmail);
    localStorage.setItem('GoBack', backUrl);
    localStorage.setItem('LogOut', logOutPath);
    queryParameters.delete('uldtoken');
    localStorage.removeItem('token');
    localStorage.removeItem('RFS');
    localStorage.removeItem('EMAIL');
    localStorage.removeItem('ASR');
    history.push({
      pathname: location.pathname,
    });
    console.log('***', location.pathname);
    window.location.replace(process.env.REACT_APP_ULD_URL) // redirect to RFS dashboard
  } else if (tokenEmail != "" && tokenEmail != null) {
    localStorage.setItem('EMAIL', tokenEmail);
    localStorage.setItem('User_Type', userType);
    localStorage.setItem('CEmail', recEmail);
    localStorage.setItem('CData', emailData);
    queryParameters.delete('EMAIL');
    // localStorage.removeItem('token');
    // localStorage.removeItem('RFS');
    // localStorage.removeItem('ULD');
    history.push({
      pathname:  location.pathname,
    });
    console.log('***', location.pathname);
    window.location.replace('/Confirmation-form') // redirect to RFS dashboard
  } else if (tokenASR != "" && tokenASR != null) {
    localStorage.setItem('ASR', tokenASR);
    localStorage.setItem('OrgType', orgType);
    localStorage.setItem('User', userName);
    localStorage.setItem('Email', userEmail);
    localStorage.setItem('GoBack', backUrl);
    localStorage.setItem('LogOut', logOutPath);
    queryParameters.delete('service_recovery_token');
    localStorage.removeItem('token');
    localStorage.removeItem('RFS');
    localStorage.removeItem('ULD');
    localStorage.removeItem('EMAIL');
    // history.push({
    //   pathname: location.pathname,
    // });
    // console.log('***', location.pathname);
    // window.location.replace(process.env.REACT_APP_ASR_URL) // redirect to RFS dashboard
    if (localStorage.getItem('OrgType') == 'A') {
      window.location.replace(process.env.REACT_APP_ASR_URL) // redirect to RFS dashboard
    } else if (localStorage.getItem('OrgType') == 'H') {
      window.location.replace(process.env.REACT_APP_HSR_URL)
    }
  } else if (localStorageDataRFS != "" && localStorageDataRFS != null && !localStorageDataEmail) {
    window.location.replace(process.env.REACT_APP_BOOKINGTRUCK_URL) // redirect to RFS dashboard
  } else if (localStorageDataULD != "" && localStorageDataULD != null && !localStorageDataEmail) {
    window.location.replace(process.env.REACT_APP_ULD_URL) // redirect to RFS dashboard
  } else if (localStorageDataEmail != "" && localStorageDataEmail != null) {
    window.location.replace('/Confirmation-form') // redirect to RFS dashboard
  } 
  else if (localStorageDataASR != "" && localStorageDataASR != null && !localStorageDataEmail) {
    if (localStorage.getItem('OrgType') == 'A') {
      window.location.replace(process.env.REACT_APP_ASR_URL) // redirect to RFS dashboard
    } else if (localStorage.getItem('OrgType') == 'H') {
      window.location.replace(process.env.REACT_APP_HSR_URL)
    }
  } 
  else {
    const baseUrl = new URL(process.env.REACT_APP_MAIN_URL);
    const currentUrl = new URL(window.location.href);
    if (currentUrl.pathname === baseUrl.pathname) {
      // window.location.replace(process.env.REACT_APP_LOGIN_URL); // Redirect to base URL OLD
      // window.location.replace(localStorage.getItem('LogOut')); // Redirect to base URL
      if (logUrl != null) {
        window.location.replace(localStorage.getItem('LogOut'));
      } else {
        window.location.replace(process.env.REACT_APP_LOGIN_URL)
      }

    } else {
      // window.location.replace(process.env.REACT_APP_LOGIN_URL + currentUrl.pathname); // Redirect to base URL with current path
      // window.location.replace(localStorage.getItem('LogOut'));
      if (logUrl != null) {
        window.location.replace(localStorage.getItem('LogOut'));
      } else {
        window.location.replace(process.env.REACT_APP_LOGIN_URL)
      }
    }
    // window.location.replace(process.env.REACT_APP_LOGIN_URL)

    if (logUrl != null) {
      window.location.replace(localStorage.getItem('LogOut'));
    } else {
      window.location.replace(process.env.REACT_APP_LOGIN_URL)
    }
    // window.location.replace(process.env.REACT_APP_LOGIN_URL) // Back to loginpage
    // window.location.replace(localStorage.getItem('LogOut'));
  }
}

export default LoadingPage;
